import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadScriptService {

    constructor() {
    }

    get(url: string): Observable<any> {
        return Observable.create(observer => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.onload = () => {
                observer.next({script: url, status: 'loaded'});
                observer.complete();
            };
            script.onerror = (error: any) => {
                observer.error(error);
                observer.complete();
            };

            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }
}
